module.exports = ($) => {
  // Disabled buttons are always disabled
  $(document).on("click", "a.disabled, .btn.disabled", () => false);
};
